<template>
    <div class="grid">
        <h5 col-6>{{surname}} {{name}} {{patronymic}}</h5>
    </div>

</template>

<script>
    export default {
        name: "Person",
        computed: {
            name: {
                get() {
                    return this.$store.getters.Q_ONE.name
                }
            },
            surname: {
                get() {
                    return this.$store.getters.Q_ONE.surname
                }
            },
            patronymic: {
                get() {
                    return this.$store.getters.Q_ONE.patronymic
                }
            }
        }
    }
</script>

<style scoped>
    .header {
        text-align: left;
        padding-bottom: 0;
        margin-bottom: 0;
    }

    table {
        margin-top: 0;
        width: 100%;
    }

    table, th, td {

        border: 1px solid black;
        border-collapse: collapse;
    }

    th, td {
        padding: 5px;
        text-align: right;
    }

    .value {
        text-align: left;
        padding: 0;
    }
    .value, .label {
        width: 50%;
    }

    .filled {
        background-color: white;
    }

</style>